import { Injectable } from '@angular/core';

import { ConfigurationService } from '../../../services/configuration.service';

@Injectable()
export class DoctorScheduleService extends ConfigurationService {

    public modelPath = 'configuration/doctor_schedules';
}
